import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'batchSn';

const batchSnService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },
};
export default batchSnService;
